module.exports = __webpack_public_path__ + "img/case7.dc749dfd.png";